<template>
    <Head title="Login" />
    <GuestLayout :showExtras="false" :showBackButton="false" :showBottomBarInDesktop="true" :showBottomBarInMobile="true">
        <article class="mt-[120px]">
            <form
                @submit.prevent="submit"
                novalidate
                class="px-5 xl:max-w-[350px] xl:min-w-[350px] sm:mt-[220px]"
            >
                <ul class="grid gap-y-5">
                    <li>
                        <label class="mb-1 mr-5 flex font-semibold pb:text-white">
                            Email
                        </label>
                        <Input
                            type="text"
                            placeholder="Exemplo: joao@email.com"
                            v-model="form.email"
                        />
                    </li>

                    <li>
                        <label class="mb-1 mr-5 flex font-semibold pb:text-white">
                            Senha
                        </label>
                        <div class="relative flex">
                            <input
                                placeholder="******"
                                ref="inputPassword"
                                id="password"
                                name="password"
                                :type="showPassword ? 'text' : 'password'"
                                class="form-input border border-gray-500 rounded-2xl m-[1px] w-full selected:border-blue-800 focus:border-2 focus:m-0 disabled:opacity-50 disabled:border-gray-800 disabled:bg-gray-300"
                                v-model="form.password"
                                required
                                autocomplete="current-password"
                            />
                            <div
                                class="absolute self-center right-0 mr-3 text-xs font-bold cursor-pointer"
                                @click="showPassword = !showPassword"
                            >
                                <span v-if="!showPassword">EXIBIR</span>
                                <span v-if="showPassword">OCULTAR</span>
                            </div>
                            <!-- <span>HIDE</span> -->
                        </div>
                        <div class="flex justify-between text-xs pt-2">
                            <label class="flex items-center gap-x-1 pb:text-white sm:text-primary">
                                <input type="checkbox" v-model="saveForm"/>
                                Se manter conectado
                            </label>

                            <Link
                                ref="passwordRequest"
                                :href="route('password.request')"
                                class="hover:underline hover:text-blue-600 pb:text-white"
                            >
                                Esqueceu a senha?
                            </Link>
                        </div>
                    </li>

                    <li>
                        <Button :enabled="allIsValid" :isAutoLoading="true" label="Acessar"/>
                        <p
                            v-if="$page.props.flash.error"
                            class="text-[12px] text-error mt-2"
                        >
                        <strong>
                            {{ $page.props.flash.error }}
                        </strong>
                        </p>
                    </li>
                </ul>
            </form>
        </article>
    </GuestLayout>
</template>

<script>
import Input from "@/Components/UI/Form/Input.vue";
import Checkbox from "@/Components/Checkbox.vue";
import GuestLayout from "@/Layouts/Guest.vue";
import Label from "@/Components/Label.vue";
import ValidationErrors from "@/Components/ValidationErrors.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";
import HeadingGuest from "@/Components/UI/Texts/HeadingGuest.vue";
import Button from "@/Components/LoaderButton.vue";

export default {
    components: {
        Checkbox,
        Input,
        Label,
        ValidationErrors,
        Head,
        Link,
        GuestLayout,
        HeadingGuest,
        Button,
    },

    props: {
        canResetPassword: Boolean,
        canRegister: Boolean,
        status: String,
    },

    data() {
        return {
            form: {
                email: sessionStorage.getItem("email"),
                password: sessionStorage.getItem("password"),
            },
            saveForm: sessionStorage.getItem("saveForm"),
            showPassword: false,
        };
    },

    computed: {
        allIsValid: function () {
            if (this.validateEmail(this.form.email) && this.form.password) {
                return true;
            } else {
                return false;
            }
        },
    },
    methods: {
        validateEmail(email) {
            return String(email)
                .trim()
                .toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
        },
        submit() {
            if (this.saveForm) {
                sessionStorage.setItem("email", this.form.email.trim());
                sessionStorage.setItem("password", this.form.password);
                sessionStorage.setItem("saveForm", this.saveForm);
            } else {
                sessionStorage.removeItem("email");
                sessionStorage.removeItem("password");
                sessionStorage.removeItem("saveForm");
            }

            this.$inertia.post(this.route("login"), {
                cpf: this.form.email,
                password: this.form.password,
            });
        },
        showPass() {
            this.showPassword = !this.showPassword;
        },
    },
};
</script>
